import { createStore } from "solid-js/store";
import { hydrate } from "../hydration/index.js";
/**
 * Wrapper around Solid.js store
 */
export class ObjectStorage {
    store;
    set;
    /**
     * Create new object storage
     */
    constructor() {
        const [store, setStore] = createStore({});
        this.store = store;
        this.set = setStore;
        this.get = this.get.bind(this);
    }
    /**
     * Get object by ID
     * @param id ID
     * @returns Object
     */
    get(id) {
        return this.store[id];
    }
    /**
     * Hydrate some data into storage
     * @param id ID
     * @param type Hydration type
     * @param context Context
     * @param data Input Data
     */
    hydrate(id, type, context, data) {
        if (data) {
            data = { partial: false, ...data };
            this.set(id, hydrate(type, data, context, true));
        }
    }
    /**
     * Hydrate some data without putting it into storage. Call {@link add}
     * afterwards to add the hydrated value into storage.
     * @param type Hydration type
     * @param context Context
     * @param data Input Data
     * @returns The hydrated type
     */
    hydrateOnly(type, context, data) {
        data = { partial: false, ...data };
        return hydrate(type, data, context, true);
    }
    /**
     * Add a previously hydrated object to the storage
     * @param id ID
     * @param toAdd Hydrated object
     */
    add(id, toAdd) {
        this.set(id, toAdd);
    }
}
